import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import i18n from '../../i18n/i18n';
import {getSupportedLanguages} from '../../utils/getLanguage';
import styles from '../../css/MobileLanguagePage.module.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default function MobileLanguagePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation();
  const [languageCode, setLanguageCode] = useState(i18n.language);
  const supportedLanguages = getSupportedLanguages();
  const queryParams = new URLSearchParams(location.search);
  const isFromQr = (queryParams.get('isFromQr') === "true");

  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const regionRef = useRef(null);

  useEffect(() => {
    const setHeight = () => {
      const top = topRef.current ? topRef.current.offsetHeight : 0;
      const bottom = bottomRef.current ? bottomRef.current.offsetHeight : 0;
      const totHeight = window.innerHeight;
      if (regionRef.current) {
        regionRef.current.style.height = `${totHeight - top - bottom - 40}px`;
      }
    };
    setHeight();
    window.addEventListener('resize', setHeight);
    return () => {
      window.removeEventListener('resize', setHeight);
    };
  }, []);

  const handleCancelClick = () => {
    if (isFromQr) {
      navigate(`/gsmpi-web/mobile/${i18n.language}/bridge${location.search}`, { replace: true });
    } else {
      navigate(`/gsmpi-web/mobile/${i18n.language}/bridge${location.search}`);
    }
  };

  const handleChangeLanguageClick = () => {
    i18n.changeLanguage(languageCode).then(() => {
      if (isFromQr) {
        navigate(`/gsmpi-web/mobile/${i18n.language}/bridge${location.search}`, { replace: true });
      } else {
        navigate(`/gsmpi-web/mobile/${i18n.language}/bridge${location.search}`);
      }
    });
  };

  const handleItemClick = (event, item) => {
    event.preventDefault();
    setLanguageCode(item.code);
  };

  return (
    <div className={cx('mpi-all-wrap')}>
      <div className={cx('mpi-bg')}></div>
      <div className={cx('mpi-pop-wrap-mobile.smallscreen')}>
        <div className={cx('mpi-box')}>
          <div ref={topRef} className={cx('mpi-boxtop')}>
            <h1 className={cx('mpi-title', 'prevpage')}>{t('pay.gsmpi.changeRegion.msg1')}</h1>
          </div>
          <div className={cx('mpi-content', 'mpi-step-changeregion')}>
            <div ref={regionRef} className={cx('mpi-region')}>
              <ul className={cx('mpi-region-list')}>
                {supportedLanguages.map((item) => (
                  <li key={item.code}>
                    <a className={cx('region', languageCode === item.code ? "active" : "")} href="#" onClick={(event) => handleItemClick(event, item)}>
                      <span className={cx('mpi-region-name')}>{item.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div ref={bottomRef} className={cx('mpi-boxbottom')}>
            <div className={cx('mpi-button', 'isClearfix')}>
              <button type="button" className={cx('mpi-button-cancel-mobile')} onClick={handleCancelClick}>
                {t('pay.gsmpi.main.button1')}
              </button>
              <button type="button" className={cx('mpi-button-submit-mobile')} onClick={handleChangeLanguageClick}>
                {t('pay.gsmpi.changeRegion.button2')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}